var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#5494C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.3753L21.1163 18.4915L19.5 20.1078V15.0003H18.25V20.1078L16.6337 18.4915L15.75 19.3753L18.875 22.5003L22 19.3753Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 21.25L8.25 21.2503V6.25029H13.25V10.0003C13.251 10.3315 13.383 10.6489 13.6172 10.8831C13.8514 11.1173 14.1688 11.2493 14.5 11.2503H18.25V13.75H19.5V10.0003C19.5022 9.91815 19.4866 9.83651 19.4542 9.76098C19.4219 9.68545 19.3735 9.61784 19.3125 9.56279L14.9375 5.18779C14.8827 5.12645 14.8151 5.07788 14.7396 5.04548C14.664 5.01309 14.5822 4.99766 14.5 5.00029H8.25C7.91878 5.00128 7.60142 5.13329 7.36721 5.3675C7.133 5.6017 7.00099 5.91907 7 6.25029V21.2503C7.00099 21.5815 7.133 21.8989 7.36721 22.1331C7.60142 22.3673 7.91878 22.4993 8.25 22.5003H15.75V21.25ZM14.5 6.50029L18 10.0003H14.5V6.50029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterDownload);
export default __webpack_public_path__ + "static/media/letter-download.da346d399a7c83eaa1a5f9bac4548508.svg";
export { ForwardRef as ReactComponent };